import React from "react";
import fallbackOpenGraph from "@images/checksmart-opengraph.png";

export interface SeoPropTypes {
  seo_metadata__title_tag: { value: string };
  seo_metadata__meta_description?: { value: string };
  seo_metadata__open_graph_image?: { value: [{ url: string }] };
  seo_metadata__noindex?: { value: [{ codename: string }] };
  seo_metadata__page_schema?: { value: string };
  seo_metadata__redirect_page_to?: { value: string };
  faq_schema?: { value: string };
}

const SEO = (props: SeoPropTypes) => {
  // Function to retrieve the title or provide a default if missing
  const getTitle = () => props.seo_metadata__title_tag.value || "CheckSmart";
  // Function to retrieve the meta description or provide a default if missing
  const getMetaDescription = () =>
    props.seo_metadata__meta_description?.value ||
    "CheckSmart - Payday Loans, Installment Loans, Title Loans, Line of Credit, and More!";
  // Function to retrieve the Open Graph image or use a fallback if missing
  const getOpenGraphImage = () =>
    props?.seo_metadata__open_graph_image?.value[0]?.url || fallbackOpenGraph;
  // Function to retrieve the 'noindex' value or use an empty string if missing
  const getNoIndex = () =>
    props?.seo_metadata__noindex?.value[0]?.codename || "";
  // Function to render meta tags with the specified name and content
  const renderMetaTag = (name: string, content: string) => (
    <meta name={name} content={content} />
  );
  // Funtion to grab the article schema for "BLOG POSTS"
  const renderArticleSchema = () =>
    props?.seo_metadata__page_schema?.value || "";
  const renderFAQSchema = () => props?.faq_schema?.value || "";
  const redirectLink = props?.seo_metadata__redirect_page_to?.value || null;
  if (typeof window !== "undefined" && redirectLink) {
    window.location.href = redirectLink;
    return null;
  }
  return (
    <>
      <meta charSet="utf-8" />
      <title>{getTitle()}</title>
      {getMetaDescription() && (
        <>
          {renderMetaTag("description", getMetaDescription())}
          {renderMetaTag("og:description", getMetaDescription())}
          {renderMetaTag("twitter:description", getMetaDescription())}
        </>
      )}
      {renderMetaTag("og:title", getTitle())}
      {renderMetaTag("og:image", getOpenGraphImage())}
      {renderMetaTag("twitter:card", "summary")}
      {renderMetaTag("twitter:title", getTitle())}
      {getNoIndex() && renderMetaTag("robots", getNoIndex())}
      {!!renderArticleSchema() && (
        <script type="application/ld+json">{renderArticleSchema()}</script>
      )}
      {!!renderFAQSchema() && (
        <script type="application/ld+json">{renderFAQSchema()}</script>
      )}
    </>
  );
};

export default SEO;
